export const getStatusLabel = (item) => {
  if (item?.isSettled || Number(item?.remaining || 0) <= 0) return 'Settled';
  if (Number(item?.progress || 0) > 0) return 'Partial';
  return 'Outstanding';
};

export const getStatusMeta = (item) => {
  const label = getStatusLabel(item);
  if (label === 'Settled') {
    return { label, classes: 'bg-emerald-50 text-emerald-700 border border-emerald-100' };
  }
  if (label === 'Partial') {
    return { label, classes: 'bg-amber-50 text-amber-700 border border-amber-100' };
  }
  return { label, classes: 'bg-rose-50 text-rose-700 border border-rose-100' };
};

export const canDeleteRecord = (item) => Boolean(item && item.isSettled && Number(item.remaining || 0) <= 0);
